import { useState, useEffect } from "react";
import logo from "../logo.svg";
import "../App.css";
import {
  HashRouter as Router,
  Switch,
  Route,
  Routes,
  Link,
  useResolvedPath,
} from "react-router-dom";


import Home from "./Home";
import System from "./System";
import Rooms from "./Rooms";
import HomeSpaces from "../App/Rooms/homeSpaces";
import PublicSpaces from "../App/Rooms/publicSpaces";

import Products from "./Products";
import ListProducts from "./Products/ListProducts";
import SlideProducts from "./Products/SlideProducts";
import Finishes from "./Finishes";
import Downloads from "./Downloads";
import Videos from "./Videos";
import Product from "./Products/ListProducts/Product";

import WallPanelling from "./System/Modularities/Wallpanelling";
import Wardrobes from "./System/Modularities/Wardrobes";
import StorageUnits from "./System/Modularities/Storageunits";
import WalkInClosets from "./System/Modularities/Walkinclosets";
import UnikoSystem from "./System/Modularities/Unikosystem";
import BookCases from "./System/Modularities/Bookcases";
import LayoutCombinations from "./Rooms/LayoutCombinations";
import Compositions from "./Rooms/compositions";
import CompositionImage from "./Rooms/compositionImage";
import HomeImg from "./SplashScreen";


import { useRouteMatch } from "react-router-dom";
import Help from "./Help";
import ReactGA from "react-ga4";

function App() {
  const [splash, setSplash] = useState(true);
  // const url = useResolvedPath("").pathname;

  useEffect(() => {

    ReactGA.initialize("G-0Z0D3S9TL5");
    ReactGA.send(document.location.pathname);

    //eslint-disable-next-line
  }, [document.location.pathname])



  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <Routes>
            {splash ? (
              <Route
                path="/"
                element={<HomeImg setSplash={setSplash}></HomeImg>}
              />
            ) : (
              <Route path="/" element={<Home></Home>} />
            )}
            <Route
              path="/system"
              element={<System setSplash={setSplash}></System>}
            />
            <Route
              path="/rooms"
              element={<Rooms setSplash={setSplash}></Rooms>}
            />
            <Route path="/help" element={<Help setSplash={setSplash}></Help>} />

            <Route
              path="/home-spaces"
              element={<HomeSpaces setSplash={setSplash}></HomeSpaces>}
            />
            <Route
              path="/public-spaces"
              element={<PublicSpaces setSplash={setSplash}></PublicSpaces>}
            />

            <Route
              path="/products"
              element={<Products setSplash={setSplash}></Products>}
            />
            <Route
              path="/product/:categoryId/:id"
              element={<Product setSplash={setSplash}></Product>}
            />
            <Route
              path="/layout-combinations/:id"
              element={
                <LayoutCombinations setSplash={setSplash}></LayoutCombinations>
              }
            ></Route>
            <Route
              path="/composition-image/:id"
              element={
                <CompositionImage setSplash={setSplash}></CompositionImage>
              }
            ></Route>
            <Route
              path="/composition/:id"
              element={<Compositions setSplash={setSplash}></Compositions>}
            ></Route>
            <Route
              path="/products/list/:id"
              element={<ListProducts setSplash={setSplash}></ListProducts>}
            />
            <Route
              path="/products/slide/:id/"
              element={<SlideProducts setSplash={setSplash}></SlideProducts>}
            />
            <Route
              path="/finishes"
              element={<Finishes setSplash={setSplash}></Finishes>}
            />

            <Route
              path="/downloads"
              element={<Downloads setSplash={setSplash}></Downloads>}
            />
            <Route
              path="/videos"
              element={<Videos setSplash={setSplash}></Videos>}
            />

            <Route
              path="/wallpanelling"
              element={<WallPanelling setSplash={setSplash}></WallPanelling>}
            />
            <Route
              path="/wardrobes"
              element={<Wardrobes setSplash={setSplash}></Wardrobes>}
            />

            <Route
              path="/storageunits"
              element={<StorageUnits setSplash={setSplash}></StorageUnits>}
            />

            <Route
              path="/walkinclosets"
              element={<WalkInClosets setSplash={setSplash}></WalkInClosets>}
            />

            <Route
              path="/unikosystem"
              element={<UnikoSystem setSplash={setSplash}></UnikoSystem>}
            />
            <Route
              path="/bookcases"
              element={<BookCases setSplash={setSplash}></BookCases>}
            />
          </Routes>
        </header>
      </div>
    </Router>
  );

  // );
}

export default App;
